export default __webpack_public_path__ + "static/media/lost.f5af7056.svg";